import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import styles from '../../../styles';

const Fade = ({ children, ...props }) => (
  <CSSTransition {...props} timeout={1500} classNames="fade">
    {children}
  </CSSTransition>
);

const rotate = keyframes`
from {
    transform: rotateZ(0deg) translate3d(0,0,0);
  }
  to {
    transform: rotateZ(360deg) translate3d(0,0,0);
  }
`;

const ActivityIndicatorOrbit = styled.div`
  position: relative;
  display: flex;
  width: 4.5rem;
  height: 4.5rem;
  svg {
    position: absolute;
    color: ${styles.color.CHARCOAL};

    &.second {
      color: ${styles.color.ORANGE};
      animation: ${rotate} 1s linear infinite;
      //opacity: .7;
    }
    &.third {
      color: ${styles.color.ORANGE};
      animation: ${rotate} 1.5s linear infinite;
      //opacity: .4;
    }

    circle {
      fill: currentColor;
      stroke: none;
    }
  }
`;

const Wrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100000;
  pointer-events: none;
  background: ${styles.color.WHITE};
  transform-origin: 100% 50%;
  transform: scale(1, 1) translate3d(0,0,0);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;

  &.fade-exit {
    transform: scale(1, 1) translate3d(0,0,0);
  }

  &.fade-exit.fade-exit-active {
    transform: scale(0, 1) translate3d(0,0,0);
    transition: transform 0.5s ${styles.easing.inOutCubic};
    transition-delay: 1s;
  }
`;

const BlockingLoader = props => {
  const { isLoading } = props;
  return (
    <Fade in={isLoading} unmountOnExit>
      <Wrapper loading={isLoading}>
        <ActivityIndicatorOrbit>
          <svg viewBox="0 0 72 72" className="first">
            <circle cx="36" cy="36" r="6" />
          </svg>
          <svg viewBox="0 0 72 72" className="second">
            <circle cx="20" cy="20" r="4" />
          </svg>
          <svg viewBox="0 0 72 72" className="third">
            <circle cx="12" cy="12" r="2" />
          </svg>
        </ActivityIndicatorOrbit>
      </Wrapper>
    </Fade>
  );
}

BlockingLoader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
}

export default BlockingLoader;


// WEBPACK FOOTER //
// ./src/modules/core/components/BlockingLoader.js